import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { SCUIGeneralModal, SCUISnackbar } from "../../../../atomic/molecules";
import {
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { SCUIButton } from "../../../../atomic/atoms";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { RuleServiceCommand } from "../../../../services/command";
import { RuleTenant } from "../../RuleService.const";
import { enumSnackbarStatusType } from "../../../../types/enums";
import {
  getSnackbarValue,
  validateCriteriaTypes,
} from "../../helper/RuleModal.helper";

export const SCUICriteriaTypeModal: FC<{
  open: boolean;
  tenant: any;
  onClose: any;
}> = ({ open, tenant, onClose }) => {
  const { t } = useTranslation();
  const [snackbar, setSnackbar] = useState({
    show: false,
    message: "",
    status: enumSnackbarStatusType.success,
  });
  const [modalState, setModalState] = useState({
    Id: "",
    Key: "",
    Name: "",
    Tenant: tenant,
    hasPredefinedValue: false,
    criteriaTypeValues: [] as any,
  });

  const save = async (modalState: any) => {
    let currentPayload = modalState;
    let validation = validateCriteriaTypes(currentPayload);
    if (!validation.isValid) {
      setSnackbar({
        show: true,
        message: validation.messages.join(", "),
        status: enumSnackbarStatusType.danger,
      });
      return;
    }
    if (currentPayload) {
      let response = await RuleServiceCommand.CreateCriteriaType({
        CriteriaType: currentPayload,
      });
      let snackBarSettings = getSnackbarValue(response);
      onClose(snackBarSettings);
    }
  };

  const updateChildItem = (value: any, index: number, key: any) => {
    let criteriaTypeValues = modalState.criteriaTypeValues;
    criteriaTypeValues[index][key] = value;
    setModalState((prevState) => ({
      ...prevState,
      criteriaTypeValues: criteriaTypeValues,
    }));
  };
  const removeChildItem = (index: number) => {
    modalState.criteriaTypeValues.splice(index, 1);
    setModalState((prevState) => ({
      ...prevState,
      criteriaTypeValues: modalState.criteriaTypeValues,
    }));
  };
  const addItemToCriteriaTypeValue = () => {
    let value = modalState.criteriaTypeValues;
    value.push({ Name: "", Value: "" });
    setModalState((prevState) => ({
      ...prevState,
      criteriaTypeValues: value,
    }));
  };
  return (
    <SCUIGeneralModal
      width={"xs"}
      open={open}
      onClose={onClose}
      title={t(`ruleManagement.modal.criteriaType.title`)}
      buttonText={t("general.save")}
    >
      <Grid container sx={{ padding: "2rem" }} style={{ display: "flex" }}>
        <FormControl fullWidth>
          <TextField
            required={true}
            sx={{ paddingBottom: "1rem" }}
            value={modalState.Key}
            label={t(`ruleManagement.fields.criteriaType.key.name`)}
            disabled={false}
            multiline
            onChange={(event: any) => {
              setModalState((prevState) => ({
                ...prevState,
                Key: event.target.value,
              }));
            }}
            fullWidth
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            required={true}
            sx={{ paddingBottom: "1rem" }}
            value={modalState.Name}
            label={t(`ruleManagement.fields.criteriaType.name.name`)}
            disabled={false}
            multiline
            onChange={(event: any) => {
              setModalState((prevState) => ({
                ...prevState,
                Name: event.target.value,
              }));
            }}
            fullWidth
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            required={true}
            sx={{ paddingBottom: "1rem" }}
            value={RuleTenant[tenant as keyof typeof RuleTenant]}
            label={"Tenant"}
            disabled={true}
            multiline
            fullWidth
          />
        </FormControl>
        <FormControl fullWidth sx={{ paddingBottom: "2rem" }}>
          <FormLabel id="demo-controlled-radio-buttons-group">
            {t(`ruleManagement.modal.criteriaType.question`)}
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={modalState.hasPredefinedValue}
            onChange={(event) => {
              setModalState((prevState) => ({
                ...prevState,
                hasPredefinedValue: event.target.value === "true",
              }));
            }}
          >
            <FormControlLabel
              value="true"
              control={<Radio />}
              label={t(`ruleManagement.modal.criteriaType.approve`)}
            />
            <FormControlLabel
              value="false"
              control={<Radio />}
              label={t(`ruleManagement.modal.criteriaType.decline`)}
            />
          </RadioGroup>
        </FormControl>
        {modalState.hasPredefinedValue && (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ width: 100 }}>
              <IconButton
                size="small"
                sx={{ paddingTop: "1rem" }}
                onClick={() => {
                  addItemToCriteriaTypeValue();
                }}
              >
                <AddIcon />
                {t("general.add")}
              </IconButton>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              {modalState.criteriaTypeValues &&
                modalState.criteriaTypeValues.map((item: any, key: number) => (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "start",
                    }}
                  >
                    <FormControl
                      fullWidth
                      style={{ width: 150, margin: "20px" }}
                    >
                      <TextField
                        sx={{ paddingBottom: "1rem", flex: 0.9 }}
                        label={t(
                          `ruleManagement.fields.criteriaType.child.name`
                        )}
                        size="medium"
                        onChange={(event: any) => {
                          updateChildItem(event.target.value, key, "Name");
                        }}
                      />
                    </FormControl>
                    <FormControl
                      fullWidth
                      style={{ width: 150, margin: "20px" }}
                    >
                      <TextField
                        label={t(
                          `ruleManagement.fields.criteriaType.child.value`
                        )}
                        sx={{ paddingBottom: "1rem", flex: 0.9 }}
                        size="medium"
                        onChange={(event: any) => {
                          updateChildItem(event.target.value, key, "Value");
                        }}
                      />
                    </FormControl>
                    <IconButton
                      size="small"
                      onClick={() => {
                        removeChildItem(key);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                ))}
            </div>
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row-reverse",
            width: "100%",
          }}
        >
          <div className="m-l-16">
            <SCUIButton
              type="primary"
              sizeType="fixed"
              text={t("general.save")}
              onClick={() => {
                save(modalState);
              }}
              size="s"
            ></SCUIButton>
          </div>

          <SCUIButton
            type="secondary"
            sizeType="fixed"
            text={t("general.cancel")}
            size="s"
            onClick={onClose}
          ></SCUIButton>
        </div>
      </Grid>
      <SCUISnackbar
        show={snackbar.show}
        messageText={snackbar.message}
        status={snackbar.status}
        autoHideDuration={2000}
        onClose={() => {
          setSnackbar({
            show: false,
            message: "",
            status: enumSnackbarStatusType.success,
          });
        }}
      />
    </SCUIGeneralModal>
  );
};
